export const checkCardNumber = (array) => {
  let result = ''

  // Проверяем символ на число
  const isNumeric = n => !isNaN(n)

  // Функция замены символа
  String.prototype.replaceAt = function (index, replacement) {
    if (index >= this.length) {
      return this.valueOf()
    }
    return this.substring(0, index) + replacement + this.substring(index + 1)
  }

  for (let i = 0; i < 9; i++) {
    // Заменяем не цифры на пустоту
    const arrTmp = []
    array.forEach((j, index) => {
      if (!isNumeric(j[i])) {
        arrTmp[index] = ' '
      } else {
        arrTmp[index] = j[i]
      }
    })

    const duplicates = arrTmp.filter((number, index, numbers) => {
      return numbers.indexOf(number) !== index
    })

    if (duplicates.length) {
      result += duplicates[0]
    } else if (arrTmp[0] !== ' ') {
      result += arrTmp[0]
    } else if (arrTmp[1] !== ' ') {
      result += arrTmp[1]
    } else {
      result += arrTmp[2]
    }
  }
  return result
}
